import { createTheme } from '@mui/material/styles';
import { colors } from 'styles/colors';
import CheckBoxOutlineBlankOutlined from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlined from '@mui/icons-material/CheckBoxOutlined';
import IndeterminateCheckBoxOutlined from '@mui/icons-material/IndeterminateCheckBoxOutlined';

declare module '@mui/material/styles' {
  interface Palette {
    neutral: Palette['primary'];
  }
  interface PaletteOptions {
    neutral?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutral: true;
  }
}

export const theme = createTheme({
  palette: {
    primary: { main: '#073B70' },
    secondary: { main: '#7B88A8' },
    error: { main: '#F7403C' },
    success: { main: '#00B849' },
    warning: { main: '#FFA500' },
    neutral: { main: '#142C52' },
  },

  components: {
    MuiAlert: {
      styleOverrides: {
        filledSuccess: {
          color: '#ffffff',
        },
        filledWarning: {
          color: colors.white,
        }
      },
    },
    // ✔ thinner-looking checkbox icons
    MuiCheckbox: {
      defaultProps: {
        icon: <CheckBoxOutlineBlankOutlined />,
        checkedIcon: <CheckBoxOutlined />,
        indeterminateIcon: <IndeterminateCheckBoxOutlined />,
      },
    },

    MuiListItemButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: colors.secondary,

          '& .MuiListItemText-primary': {
            fontSize: '14px',
            fontWeight: 400,
          },

          '& .MuiListItemIcon-root': {
            color: colors.secondary,
          },

          '&.Mui-selected, &.Mui-focusVisible': {
            color: colors.primary,

            '& .MuiListItemText-primary': {
              fontWeight: 500,
            },

            '& .MuiListItemIcon-root': {
              color: colors.primary,
            },
          },
        }),
      },
    },
  },
});
